import React from 'react';
import { connect } from 'react-redux';
import AppWrapper from '../app_wrapper';
import ReviewsMobile from '../components_mobile/pages/Reviews';
import ReviewsDesktop from '../components_desktop/pages/Reviews';
import { apiGet } from '../modules/api';
import metadata from '../helpers/metadataHelper';

const ReviewsComponent = props => (
  <>
    <AppWrapper
      desktopComp={<ReviewsDesktop {...props} />}
      mobileComp={<ReviewsMobile {...props} />}
      metadata={metadata.reviews}
    />
  </>
);

ReviewsComponent.getInitialProps = ({ store, req, res }) => store.dispatch(apiGet('api/home', req, res));

const mapStateToProps = () => ({});

const Reviews = connect(mapStateToProps)(ReviewsComponent);
export default Reviews;
